import React from 'react';
import superagent from 'superagent';

import AccountReport from './AccountReport.jsx';

import {
    Segment,
    Header,
    Tab,
    Statistic } from 'semantic-ui-react'

const DISABLE_CHECK_TEXT = "Disable this account!"
const MAX_BAN_REASON_LENGTH = 10;

export default class AccountReportsList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            reports: null,
        };
    }

    async componentDidMount() {
        try {
            this.setState({ reports: null });
            const res = await superagent.get(`/api/admin/account/${this.props.account.id}/reports`).accept('json');
            console.log(res.body);
            this.setState({ reports: res.body });
        } catch (e) {
            console.log(e);
        }
    }

    renderReports(reports) {
        if (reports && reports.length > 0) {
            return (
                <Segment basic>
                    {reports.map((report, reportIndex) => {
                        return <AccountReport report={report} />
                    })}
                </Segment>
            );
        } else {
            return (<div />);
        }
    }

    render() {
        if (this.props.account) {
            let panes = (<div />);
            if (this.state.reports) {
                panes = [
                    { menuItem: `Reports Against (${this.state.reports.reportsAgainst.length})`, render: () => <Tab.Pane>{this.renderReports(this.state.reports.reportsAgainst)}</Tab.Pane> },
                    { menuItem: `Reports Created By ${this.props.account.username} (${this.state.reports.reportsBy.length})`, render: () => <Tab.Pane>{this.renderReports(this.state.reports.reportsBy)}</Tab.Pane> },
                    { menuItem: `Room Reports Against ${this.props.account.username} (${this.state.reports.roomReportsAgainst.length})`, render: () => <Tab.Pane>{this.renderReports(this.state.reports.roomReportsAgainst)}</Tab.Pane> }
                ];
            }

            return (
                <div>
                    <Header as="h2">Reports History</Header>
                    <Tab panes={panes} />
                </div>
            );
        }
    }
}
